import h from 'hyperscript';

import {
  DESELECT_EVENT,
  PaletteItem,
  SELECT_EVENT
} from 'cadenza/map/classic-sketch-layer/sketch-sidebar/palette-item';

import './sketch-sidebar.css';
import i18n from './sketch.properties';
import { SketchFeaturePropertiesEditor } from './sketch-feature-properties-editor/sketch-feature-properties-editor';

const NAME = 'd-sketch-sidebar-classic-content';

const NOOP = () => { /* do nothing */ };

export const DELETE_KEY_CODE = 46;

export class SketchSidebarContent extends HTMLElement {

  constructor (sketch, options) {
    super();
    this._onPaletteItemSelect = options.onPaletteItemSelect || NOOP;
    this._onPaletteItemsDeselect = options.onPaletteItemsDeselect || NOOP;
    this._onPaletteRedraw = options.onPaletteRedraw || NOOP;

    this.classList.add(NAME);
    this._standardToolsPaletteItemsContainer = this._createPaletteItemsContainer(
      '.standard-tools-palette-container',
      { withLabels: false, hideIfEmpty: true, itemsClass: 'small-item' });
    this._attachPaletteItemsListeners();
    this.append(this._standardToolsPaletteItemsContainer.container);
    this.append(
      h('details.d-panel-section', { open: true }, [
        h('summary.block-title',  i18n('sketch-sidebar.geometry-options-container.title')),
        new SketchFeaturePropertiesEditor(sketch)
      ])
    );
  }

  addPaletteSection (palettes, onselect) {
    this._paletteItemsContainer = this._createPaletteItemsContainer('.palette-items-container', { hideIfEmpty: true });
    if (palettes && palettes.length > 0) {
      const paletteSelect = this._createPaletteSelectContainer(palettes, onselect);
      const paletteContainer = this._createPaletteContainer(paletteSelect, this._paletteItemsContainer.container);
      this.prepend(paletteContainer);
    }
  }

  updatePaletteItems (paletteId, paletteItems) {
    this._paletteItemsContainer.addAll(paletteId, paletteItems);
  }

  updateStandardToolsPaletteItems (paletteId, paletteItems) {
    this._standardToolsPaletteItemsContainer.addAll(paletteId, paletteItems);
  }

  deselectAllPaletteItems () {
    if (this._paletteItemsContainer) {
      this._paletteItemsContainer.deselectAll();
    }
    if (this._standardToolsPaletteItemsContainer) {
      this._standardToolsPaletteItemsContainer.deselectAll();
    }
  }

  onPaletteItemSelect (item) {
    this._onPaletteItemSelect(item.paletteId, item.idx);
  }

  onPaletteItemsDeselect () {
    this._onPaletteItemsDeselect();
  }

  onPaletteRedraw () {
    this._onPaletteRedraw();
  }

  _createPaletteContainer (paletteSelect, paletteItems) {
    return h('details.d-panel-section', { open: true }, [
      h('summary.block-title', i18n('sketch-sidebar.palette-select-container.title')),
      h('.palette-container', [
        paletteSelect,
        h('.stretch-container', [
          paletteItems
        ])
      ])
    ]);
  }

  _createPaletteSelectContainer (palettes = [], onselect = () => {}) {
    const paletteItems = palettes.map((palette) => {
      return h('option', {
        value: palette.id,
        textContent: palette.printName
      });
    });
    return h('select.form-control', {
      onchange: (e) => {
        this._paletteItemsContainer.setLoading(true);
        onselect(e.target.value);
      },
      ...paletteItems
    });
  }

  _createPaletteItemsContainer (className, { withLabels = true, hideIfEmpty = false, itemsClass } = {}) {
    let paletteItems = [];
    const container = h(className, { hidden: hideIfEmpty });
    const loadSpinner = h('d-progress-spinner.d-progress-spinner-s', { label: i18n('sidebar.data.loading') });

    return {
      container,
      getItems: () => paletteItems,
      setLoading: (value) => {
        container.textContent = '';
        if (value) {
          container.append(loadSpinner);
        }
      },
      addAll: (paletteId, items) => {
        container.textContent = '';
        paletteItems = [];
        if (items?.length > 0) {
          container.hidden = false;
          items.forEach((item) => {
            item.paletteId = paletteId;
            const paletteItem = new PaletteItem(item, {
              withLabel: withLabels,
              className: itemsClass
            });
            paletteItems.push(paletteItem);
            container.append(paletteItem);
          });
        } else if (hideIfEmpty) {
          container.hidden = true;
        } else {
          container.append(getMessage(i18n('sidebar.data.empty-palette')));
        }
        this.onPaletteRedraw();
      },
      deselectAll: () => {
        paletteItems.forEach(item => {
          item.isSelected = false;
        });
      }
    };
  }

  _attachPaletteItemsListeners () {
    this.addEventListener(SELECT_EVENT, (event) => {
      const selectedItem = event.detail;
      const visiblePaletteItems = [
        ...this._paletteItemsContainer.getItems(),
        ...this._standardToolsPaletteItemsContainer.getItems()
      ];
      visiblePaletteItems.forEach(item => {
        item.isSelected = item === selectedItem;
      });
      this.onPaletteItemSelect(selectedItem);
    });
    this.addEventListener(DESELECT_EVENT, (event) => {
      this.onPaletteItemsDeselect(event.detail);
    });
  }

}

customElements.define(NAME, SketchSidebarContent);

function getMessage (text) {
  return h('.d-alert.d-alert-info.d-alert-small.empty-message', text);
}
